import { render, staticRenderFns } from "./LinkTenantSetting.vue?vue&type=template&id=04fc1af9&scoped=true"
import script from "./LinkTenantSetting.vue?vue&type=script&lang=js"
export * from "./LinkTenantSetting.vue?vue&type=script&lang=js"
import style0 from "./LinkTenantSetting.vue?vue&type=style&index=0&id=04fc1af9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fc1af9",
  null
  
)

export default component.exports